import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=774e4004"
import script from "./Info.vue?vue&type=script&lang=ts"
export * from "./Info.vue?vue&type=script&lang=ts"
import style0 from "./Info.vue?vue&type=style&index=0&id=774e4004&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports